import StartPanel from './StartPanel';

export default StartPanel;
